import { render, staticRenderFns } from "./FileDemo.vue?vue&type=template&id=5ed9c5a8&"
import script from "./FileDemo.vue?vue&type=script&lang=js&"
export * from "./FileDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports